import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/pages/core/abstraction/auth.service';
import { STEPS, UPLOAD_TYPE, USER_SELECTION } from 'src/app/pages/core/models/DocumentFlow';
import { MatDialogRef } from '@angular/material/dialog';
import { FormControl, Validators } from '@angular/forms';
import { DOCUMENT_STATUS } from 'src/app/pages/core/models/User';

@Component({
  selector: 'app-document-flow-dialog',
  templateUrl: './document-flow-dialog.component.html',
  styleUrls: ['./document-flow-dialog.component.scss'],
})
export class DocumentFlowDialogComponent implements OnInit {
  STEPS = STEPS;
  USER_SELECTION = USER_SELECTION;
  UPLOAD_TYPE = UPLOAD_TYPE;

  stepsHistory: STEPS[] = [];
  currentStep: STEPS;
  userResponse = {};
  fundOriginSent = false;
  enableNextButton = false;

  incomeValueControl = new FormControl(0, Validators.required);

  constructor(
    private authService: AuthService,
    public dialogRef: MatDialogRef<DocumentFlowDialogComponent>,
  ) {}

  ngOnInit(): void {
    this.initialStep();
    this.stepsHistory.push(this.currentStep);
  }

  documentUploaded() {
    this.enableNextButton = true;
  }

  initialStep() {
    if (this.fundsIsPendingOrAproved()) {
      if (this.arbitrajeDocsAreSended()) {
        this.currentStep = STEPS.FINAL_STEP_MESSAGE;
      } else if (this.certificationIsPendingOrAproved()) {
        this.currentStep = STEPS.UPLOAD_ARBITRAGE_CEDULAR;
      } else {
        this.currentStep = STEPS.UPLOAD_ARBITRAGE_CERTIFICATION;
      }
    } else {
      this.currentStep = STEPS.RELACION_DEPENDENCIA_CHOICE;
    }
  }

  choiceResponse(response: boolean) {
    let nextStep: STEPS;

    switch (this.currentStep) {
      case STEPS.RELACION_DEPENDENCIA_CHOICE:
        if (response) {
          if (this.fundsIsPendingOrAproved()) {
            nextStep = STEPS.FINAL_STEP_MESSAGE;
          } else {
            nextStep = STEPS.UPLOAD_LAST_INCOMES;
          }
        } else {
          nextStep = STEPS.MONOTRIBUTO_CHOICE;
        }
        break;
      case STEPS.MONOTRIBUTO_CHOICE:
        if (this.fundsIsPendingOrAproved()) {
          nextStep = STEPS.UPLOAD_ARBITRAGE_CERTIFICATION;
        } else {
          nextStep = response ? STEPS.UPLOAD_YEAR_INCOME : STEPS.UPLOAD_INCOME_DOC;
        }
        break;
    }

    this.changeStep(nextStep);
  }

  stepChanged(selected: USER_SELECTION) {
    if (selected === USER_SELECTION.BACK) {
      if (this.stepsHistory.length === 1) this.dialogRef.close();
      this.stepsHistory.pop();
      this.currentStep = this.stepsHistory[this.stepsHistory.length - 1];
      this.enableNextButton = false;
      return;
    } else if (selected === USER_SELECTION.END) {
      this.dialogRef.close();
      return;
    }

    let nextStep: STEPS;
    switch (this.currentStep) {
      case STEPS.UPLOAD_LAST_INCOMES:
      case STEPS.UPLOAD_YEAR_INCOME:
      case STEPS.UPLOAD_INCOME_DOC:
        nextStep = this.arbitrajeDocsAreSended()
          ? STEPS.FINAL_STEP_MESSAGE
          : STEPS.UPLOAD_ARBITRAGE_CERTIFICATION;
        break;
      case STEPS.UPLOAD_ARBITRAGE_CERTIFICATION:
        nextStep = STEPS.UPLOAD_ARBITRAGE_CEDULAR;
        break;
      case STEPS.UPLOAD_ARBITRAGE_CEDULAR:
        nextStep = STEPS.FINAL_STEP_MESSAGE;
        break;
    }

    this.changeStep(nextStep);
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  private changeStep(step: STEPS) {
    this.currentStep = step;
    this.stepsHistory.push(step);
    this.enableNextButton = false;
  }

  private fundsIsPendingOrAproved() {
    return (
      this.authService.loggedUser.fundsDocuments.funds === DOCUMENT_STATUS.PENDING ||
      this.authService.loggedUser.fundsDocuments.funds === DOCUMENT_STATUS.VALIDATED
    );
  }

  private certificationIsPendingOrAproved() {
    return (
      this.authService.loggedUser.fundsDocuments.certificacionContable ===
        DOCUMENT_STATUS.PENDING ||
      this.authService.loggedUser.fundsDocuments.certificacionContable === DOCUMENT_STATUS.VALIDATED
    );
  }

  private arbitrajeDocsAreSended() {
    return (
      this.certificationIsPendingOrAproved() &&
      (this.authService.loggedUser.fundsDocuments.impuestoCedular === DOCUMENT_STATUS.PENDING ||
        this.authService.loggedUser.fundsDocuments.impuestoCedular === DOCUMENT_STATUS.VALIDATED)
    );
  }
}
